<template>
  <div class="flex justify-center items-center h-full mt-4">
    <!-- You have requested an appointment with the following details: -->
    <!-- Book an appointment -->
 <!-- <pre>
    {{ summary_data}}
 </pre> -->
    <!-- data.purposes -->
    <!-- {{ data.appointment_date }} -->
    <!-- {{ data.selected_time }} -->
    <!-- <pre>
  {{ data }}
 </pre
    > -->
    <div class="p-4 rounded-lg bg-white w-[650px] h-[250px]">
      <div class="text-md text-center font-black border-b border-gray-800">
        You have requested an appointment with the following details:
      </div>
      <div class="py-4">
        <div class="flex py-1">
          <div class="w-1/4">Purpose:</div>
          <div class="w-full">
            {{ summary_data.purposes }}
          </div>
        </div>
        <div class="flex py-1">
          <div class="w-1/4">Details:</div>
          <div class="w-full">
            {{ summary_data.the_details }}
          </div>
        </div>
        <div class="flex py-1">
          <div class="w-1/4">Chosen Date:</div>
          <div class="w-full">
            {{ summary_data.appointment_date }}
          </div>
        </div>
        <div class="flex py-1">
          <div class="w-1/4">Chosen Time:</div>
          <div class="w-full">
            <!-- {{ theSelectedTime }} -->
            {{ summary_data.selected_time.time_table }} {{ summary_data.selected_time.am_pm }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    summary_data: {
      handler(e) {
        if (e.selected_time !== null) {
          this.theSelectedTime=e.selected_time.time_table +" " +e.selected_time.am_pm
        } else {
          console.log("IS NULL");
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      theSelectedTime: "",
    };
  },
  props: ["summary_data"],
};
</script>
